var _defs, _path, _path2, _path3, _path4, _path5, _path6, _polygon, _polygon2, _polygon3, _polygon4, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAppvizerLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 328 70.56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#1c2b58;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M201.87,24.69a6.09,6.09,0,0,0,6.39-6.17,6.39,6.39,0,0,0-12.78,0,6.09,6.09,0,0,0,6.39,6.17",
    transform: "translate(-3.63 -12.27)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M33.81,28.72V38.84c-1.44-6.75-6.9-11.06-14.08-11.06-9.49,0-16.1,7.33-16.1,19s6.61,19,16.1,19a14.52,14.52,0,0,0,9.92-3.58V58.83A6.81,6.81,0,0,1,25,60.69c-5.17,0-8.62-6-8.62-13.87S19.87,33,25,33s8.77,5.67,8.77,13.65v8.19h0V64.93H45.73V28.72Z",
    transform: "translate(-3.63 -12.27)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M82.54,27.78c-7.18,0-12.64,4.24-14.08,11V28.72H56.54V82.83l11.92-.1V54.8h0V46.61c0-8,3.74-13.65,8.77-13.65s8.62,6,8.62,13.86-3.45,13.8-8.62,13.8a6.81,6.81,0,0,1-4.61-1.86v3.48a14.45,14.45,0,0,0,9.92,3.62c9.49,0,16.1-7.33,16.1-19S92,27.78,82.54,27.78Z",
    transform: "translate(-3.63 -12.27)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M133.56,27.78c-7.19,0-12.65,4.24-14.09,11V28.72H107.55V82.83l11.92-.1V54.8h0V46.61c0-8,3.74-13.65,8.77-13.65s8.62,6,8.62,13.86-3.45,13.8-8.62,13.8a6.81,6.81,0,0,1-4.61-1.86v3.48a14.46,14.46,0,0,0,9.93,3.62c9.48,0,16.09-7.33,16.09-19S143,27.78,133.56,27.78Z",
    transform: "translate(-3.63 -12.27)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M281.05,59.47c-7.62,0-12.43-6.08-12.86-12.61V44.58c.07-11.13,2.51-15.65,7.4-15.65s6.75,3.3,6.9,15.65H272.35v2.28h21.74c0-11.79-7.36-19.08-18.5-19.08s-20.26,7.69-20.26,19,9.13,19.11,20.48,19.11c8.54,0,14.8-4.67,17.67-13l-1.08-.43C289.46,57.53,285.65,59.47,281.05,59.47Z",
    transform: "translate(-3.63 -12.27)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M329.42,28.07a18.56,18.56,0,0,0-7.25,1.42,18,18,0,0,0-5.85,3.91c-.15.14-.29.29-.43.44V28.71h-12V64.85h12V45.68a12.81,12.81,0,0,1,1-5,13.88,13.88,0,0,1,2.82-4.3,14.4,14.4,0,0,1,4.32-3,12.94,12.94,0,0,1,5.39-1.12h2.21V28.07Z",
    transform: "translate(-3.63 -12.27)"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "178.25 39.13 188.5 16.45 185.9 16.45 176.86 36.41 178.25 39.13"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "174.4 40.73 174.4 40.73 162.02 16.45 147.83 16.45 167.07 52.59 172.16 52.59 176.05 43.98 174.4 40.73"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "239.04 31.26 246.95 18.71 246.95 16.49 213.48 16.49 213.48 18.69 232.89 18.69 212.97 50.4 212.97 52.62 225.46 52.62 239.04 31.26"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "231.83 50.35 230.39 52.62 247.02 52.62 247.02 50.35 231.83 50.35"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M195.91,28.72V31h9.2V32c-5.76,6.53-9.2,13.79-9.2,22.49V64.85h12V28.72Z",
    transform: "translate(-3.63 -12.27)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppvizerLogo);
export default __webpack_public_path__ + "static/media/appvizer-logo.4cf974f94afe87520c6eac914b3b27d0.svg";
export { ForwardRef as ReactComponent };